var elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('#'+elementsForm[i]).removeClass('error');
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }
    }
    return contLogin;
}

$('.btnFormRegister').click(function () {
    $('#formRegister').submit();
});

$('#formRegister').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "nameRegister",
        "lastNameRegister",
        "identyRegister",
        "phoneRegister",
        "emailRegister",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos requeridos",
            icon: imageURL,
            button: "OK",
        });
        return false;
    }
    if( !$('#termsRegister').is(':checked') ) {
        swal({
            text: "Debes aceptar las politicas",
            icon: imageURL,
            button: "OK",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: https + "registerGo",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                swal.close();
                $("#formRegister")[0].reset();
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});
